export default "__VITE_ASSET__D2_lTlBq__"